import React from 'react';
import {
    Button,
    Form,
    Input,
    TextArea,
    Segment,
    Grid,
    Loader,
    Header,
    Radio,
    Select,
    Message,
    Card,
    Divider,
    Checkbox, Icon
} from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { DateTimePicker } from 'react-widgets';
import { ToastContainer } from 'react-toastify';


export default class OfferedMultipleAnswerQuestionCommentPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            list:[],
            showDeleteButton: this.props.showDeleteButton

        };
        this.setOptions = this.setOptions.bind(this);
    }

    componentDidMount() {
        this.setOptions()
    }
    setOptions(){
        let options=[]
        for (let i =1 ; i<= 5; i=i+1 ){
            options.push(i)
        }
        this.setState({options})
    }



    handleChange = (e, { name, value }) => {
        let list = []
       if(this.state.list.find((e)=>e===value)){
           list=this.state.list.filter((e)=>e!==value)
       }else{
           list=[...this.state.list, value]

       }
        this.setState({ list },
            localStorage.getItem('activeRole').substr(0, 13) !== 'Administrator'?
                ()=>this.props.submitOfferedMultipleAnswerCommentQuestion(this.props.questionId,this.state.list,this.props.staff,this.props.typeName, this.state.comment):
                ()=>{}
                )
    };

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {
        let question={
            text: this.props.text,
            section: 'prof',
            questionType: 'tekst',
            answerOptions: this.props.answerOptions,
            questionId: this.props.questionId
        }
        return (
            <div>

                <Header as='h4'><span style={{ color: 'red' }}>* &nbsp;</span> {question.text} {this.props.showDeleteButton && <Header as="h5" floated="right" ><span style={ {fontSize: '15px'} }>
                     <Icon name={'trash alternate'} link onClick={()=>{this.props.deleteQuestion(question.questionId)}} > </Icon>
                </span></Header>}</Header>
                <Form>
                    <Grid columns={2} centered stackable >
                        <Grid.Column width={16} stretched>

                            {  question.answerOptions.map((e)=>(
                                    <Form.Field>
                                        <Checkbox
                                            label={e.value}
                                            value= {e.id}
                                            name={e.value}
                                            checked={this.state.value}
                                            onChange={this.handleChange}
                                        />
                                    </Form.Field>

                                )

                            )}


                        </Grid.Column>

                    </Grid>
                    <Form.Field >
                        <label>
                            {/* {<FormattedMessage id="common.notification" />} */}
                            Komentar
                        </label>
                        <FormattedMessage id="poll.placeholderComment">
                            {(msg) => (<textarea
                                required
                                fluid
                                placeholder={msg}
                                control={TextArea}
                                rows="4"
                                label="Komentar"
                                value={this.state.comment}
                                name="comment"
                                onChange={(e) => {
                                    if(localStorage.getItem('activeRole').substr(0, 13) !== 'Administrator'){
                                        this.props.updateQuestionComment(question.questionId,this.props.staff,e.target.value);
                                        this.setState({ comment: e.target.value });
                                    }
                                }
                                }
                            />)}
                        </FormattedMessage>
                    </Form.Field>
                </Form>

                {this.props.showDivider && <Divider/>}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/QuestionPreviews/OfferedMultipleAnswerQuestionCommentPreview.js